export default {
    'event-calendar-event-type-label-exhibition': 'Exhibition',
    'event-calendar-event-type-label-event': 'Event',

    'event-calendar-event-card-free_slot':' ticket available',
    'event-calendar-event-card-no_free':'No more available tickets!',
};
